import React from "react";
import { Card } from "react-bootstrap";

// Importing redux components
import { useSelector } from 'react-redux';

// import { useGetUsersQuery } from "state/slices/user/userApiSlice";
// import { useGetTeamsQuery } from "state/slices/team/teamApiSlice";

const AdminDashboard = () => {
  // Retrieve Employee
  // const { data: employees } = useGetUsersQuery();
  const employees = useSelector((state) => state.employee.employees);

  // Retrieve teams
  // const { data: { teams } = {} } = useGetTeamsQuery();
  const teams = useSelector((state) => state.team.teams);

  return (
    <section className="section dashboard">
      <div className="row">
        <div className="col-lg-4 col-md-6">
          <Card className="info-card">
            <Card.Body className="pb-0">
              <Card.Title>Total Employees</Card.Title>
              <div className="d-flex align-items-center">
                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i className="bi bi-people"></i>
                </div>
                <div className="ps-3">
                  <h6>{employees?.length ? employees.length : 0}</h6>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6">
          <Card className="info-card">
            <Card.Body className="pb-0">
              <Card.Title>Total Teams</Card.Title>
              <div className="d-flex align-items-center">
                <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i className="bi bi-microsoft-teams"></i>
                </div>
                <div className="ps-3">
                  <h6>{teams?.length ? teams.length : 0}</h6>
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default AdminDashboard;
